var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "modal",
    {
      staticClass: "common-card modal-change-email-template",
      class: {},
      attrs: { name: "modalChangeEmailTemplate", height: "auto", width: 600 },
      on: { "before-open": _vm.beforeOpen, "before-close": _vm.beforeClose }
    },
    [
      _c(
        "div",
        {
          staticClass: "modal-close-img",
          on: {
            click: function($event) {
              _vm.hideModal()
            }
          }
        },
        [_c("div", { staticClass: "icon-close" })]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "modal-header" }, [
        _c("div", { staticClass: "modal-header-text h1-text" }, [
          _c("span", [_vm._v("CHANGE TEMPLATE")])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "modal-body body-text" }, [
        _vm._v(
          "\n    Changing your email template will erase any changs you have made. Are you sure you want to change your email template?\n  "
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "modal-footer group-btn" },
        [
          _vm.modalData.btnLeft != ""
            ? _c(
                "b-button",
                {
                  staticClass: "modal-btn-left ap-btn secondary",
                  on: {
                    click: function($event) {
                      _vm.hideModal()
                    }
                  }
                },
                [_vm._v("\n      " + _vm._s(_vm.modalData.btnLeft) + "\n    ")]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.modalData.btnRight != ""
            ? _c(
                "b-button",
                {
                  staticClass: "modal-btn-right ap-btn primary",
                  on: {
                    click: function($event) {
                      _vm.btnAction()
                    }
                  }
                },
                [_vm._v("\n      " + _vm._s(_vm.modalData.btnRight) + "\n    ")]
              )
            : _vm._e()
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-638f3405", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638f3405","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/modal/ModalChangeEmailTemplate.vue
// module id = 1681
// module chunks = 1